export class PasswordVaultRolesEnum {
    static readonly ADMIN = 1;
    static readonly USER = 0;
}